export const DATA_LAYER_EVENTS = {
  CLIENT_ZONE_INTERCOM_READY: 'client_zone_intercom_ready',
  CLIENT_ZONE_USER_LOADED: 'client_zone_user_loaded',
  CLIENT_ZONE_USER_LOGGED_OUT: 'client_zone_user_logged_out'
}

export const DATA_LAYER_INTERCOM_FIELDS = {
  AUTHENTICATED: 'intercom_authenticated'
}

export const DATA_LAYER_USER_FIELDS = {
  USER_NAME: 'user_name',
  USER_EMAIL: 'user_email'
}
